
import { NavItem, NavItemsService } from '@abp/ng.theme.shared';
import { Component, Input, TrackByFunction } from '@angular/core';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { EnvService } from '../../environments/env.service';
import { NhCurrentUserComponent } from './nh-current-user.component';
import { NhFullScreenComponent } from './nh-full-screen.component';

@Component({
  selector: 'nh-nav-items',
  templateUrl: 'nh-nav-items.component.html',
})
export class NhNavItemsComponent {
  trackByFn: TrackByFunction<NavItem> = (_, element) => element.id;

  constructor(public readonly navItems: NavItemsService, envService: EnvService) {
    
    navItems.removeItem(eThemeLeptonComponents.Languages);
    navItems.removeItem(eThemeLeptonComponents.CurrentUser);
    navItems.removeItem("Theme.FullScreenComponent");

    
    navItems.addItems([
      {
        id: "CurrentUser",
        order: 100,
        component: NhCurrentUserComponent
      }
    ]);

    if (envService.application.navItemFullscreen.show) {
      navItems.addItems([
        {
          id: "Fullscreen",
          order: 100,
          component: NhFullScreenComponent
        }
      ]);
    }
  }
}